import "./partials/header";
import "./pages/home";
import "./pages/schools";
import "./pages/teachers";
import "./pages/give";
import "./pages/directors";
import "./pages/registration";
import "./util/accordion";
